const actions = {
	GET_SELECT_MISSING_WORD: 'GET_SELECT_MISSING_WORD',
	GET_SELECT_MISSING_WORD_SUCCESS: 'GET_SELECT_MISSING_WORD_SUCCESS',

	CREATE_NEW_QUESTION_SELECT_MISSING_WORD: 'CREATE_NEW_QUESTION_SELECT_MISSING_WORD',
	CREATE_NEW_QUESTION_SELECT_MISSING_WORD_SUCCESS: 'CREATE_NEW_QUESTION_SELECT_MISSING_WORD_SUCCESS',

	DELETE_SELECT_MISSING_WORD: 'DELETE_SELECT_MISSING_WORD',
	DELETE_SELECT_MISSING_WORD_SUCCESS: 'DELETE_SELECT_MISSING_WORD_SUCCESS',

	GET_SELECT_MISSING_WORD_DETAIL: 'GET_SELECT_MISSING_WORD_DETAIL',
	GET_SELECT_MISSING_WORD_DETAIL_SUCCESS: 'GET_SELECT_MISSING_WORD_DETAIL_SUCCESS',

	UPDATE_SELECT_MISSING_WORD_DETAIL: 'UPDATE_SELECT_MISSING_WORD_DETAIL',
	UPDATE_SELECT_MISSING_WORD_DETAIL_SUCCESS: 'UPDATE_SELECT_MISSING_WORD_DETAIL_SUCCESS',

	LISTENING_LOADING_FALSE: 'LISTENING_LOADING_FALSE',
	//#region CRUD

	getSelectMissingWord: (model) => ({
		type: actions.GET_SELECT_MISSING_WORD,
		payload: { model },
	}),

	createQuesSelectMissingWord: (body, cbSuccess, cbError) => ({
		type: actions.CREATE_NEW_QUESTION_SELECT_MISSING_WORD,
		payload: { body },
		cbSuccess,
		cbError,
	}),

	getSelectMissingWordDetail: (id) => ({
		type: actions.GET_SELECT_MISSING_WORD_DETAIL,
		payload: { id },
	}),

	updateSelectMissingWordDetail: (model, cbSuccess, cbError) => ({
		type: actions.UPDATE_SELECT_MISSING_WORD_DETAIL,
		payload: { model },
		cbSuccess,
		cbError,
	}),

	deleteSelectMissingWord: (id, cbSuccess, cbError) => ({
		type: actions.DELETE_SELECT_MISSING_WORD,
		payload: { id },
		cbSuccess,
		cbError,
	}),
};

export default actions;
